import { Product } from 'src/app/@utils/gtm-tracking/model/Product';
import { OrderLineViewModel } from '@models/api-orders.models';
import { mapToOrderTrackableProduct } from '@utils/gtm-tracking/utils/mapToOrderTrackableProduct';

export type Affiliation = 'Online store' | 'Click & Collect';

export type PurchaseEvent = {
    event: 'purchase';
    ecommerce: {
        transaction_id: string;
        affiliation: Affiliation;
        currency?: string;
        value?: number;
        tax?: number;
        items: Product[];
        coupon?: string;
        shipping?: number;
        discount_value?: number;
    };
};

export const trackPurchaseEvent = (
    orderId: string,
    products: OrderLineViewModel[],
    totalPrice?: number,
    discountValue?: number,
    vatPrice?: number,
    coupons?: string[],
    shipping?: number,
    currency?: string,
    affiliation?: Affiliation
): PurchaseEvent => ({
    event: 'purchase',
    ecommerce: {
        transaction_id: orderId || '',
        affiliation: affiliation || 'Online store',
        currency: currency,
        value: totalPrice,
        tax: vatPrice,
        shipping: shipping,
        discount_value: discountValue || 0,
        coupon: coupons?.join('|') || '',
        items: products?.map(product => mapToOrderTrackableProduct(product)) || []
    }
});
